import React from 'react';
import { connect } from 'react-redux';

import Button from '../../components/basic/Button';
import Dialog from 'material-ui/Dialog';

import { MODALS } from '../../constants/Constants';
import * as modalActions from '../../actions/ModalActions';
import * as companyActions from '../../actions/entities/CompanyActions';

const Modal = ({ open, data, closeModal, updateCompany }) => {
  const handleClose = () => closeModal(MODALS.COMPANY_SAVE_AND_NOTIFY);
  const actions = [
    <Button label="Cancel" onClick={handleClose} />,
    <Button
      primary
      label="Save only"
      onClick={() => {
        updateCompany(data, false);
        handleClose();
      }}
    />,
    <Button
      primary
      label="Save and notify"
      onClick={() => {
        updateCompany(data, true);
        handleClose();
      }}
    />
  ];
  return (
    <Dialog
      actions={actions}
      modal={false}
      open={open}
      onRequestClose={handleClose}
      contentStyle={{ minWidth: '200px', maxWidth: '500px' }}
    >
      You can notify the operator about the changes you made if you:
      <ul>
        <li>upgraded the contract plan to free or premium</li>
        <li>increased the number of credits</li>
        <li>changed the credit expiration date</li>
      </ul>
      Would you like to save changes and notify the operator?
    </Dialog>
  );
};

const mapStateToProps = ({ modals }) => ({
  ...modals[MODALS.COMPANY_SAVE_AND_NOTIFY]
});

export default connect(mapStateToProps, { ...modalActions, ...companyActions })(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/CompanySaveAndNotifyModal.js